import React, { memo } from 'react';
import {
  Input,
} from 'semantic-ui-react';
import {
  func, bool,
} from 'prop-types';

const ModuleSearch = (props) => {
  const {
    onSearch,
    loading,
  } = props;
  const onSearchChange = (e, { value }) => {
    onSearch(value);
  };

  return (
    <div>
      <Input onChange={onSearchChange} autoFocus fluid placeholder="Search by name" icon="search" loading={loading} />
    </div>
  );
};

ModuleSearch.propTypes = {
  onSearch: func.isRequired,
  loading: bool.isRequired,
};

ModuleSearch.defaultProps = {
};

export default memo(ModuleSearch);
